<script>

export default {
    name: "button",

    props: 
    {
        to: null,
        href: null,
        variant: null,
        outline: Boolean,
        small: Boolean,
        large: Boolean,
        XLarge: Boolean,
        block: Boolean,
        icon: null,
        brand: Boolean,
        solid: Boolean,
        round: Boolean,
        blank: Boolean,
        center: Boolean,
        disabled: Boolean,
        bold: Boolean,
        semibold: Boolean,
        size: {
            type: Number,
            default: 1
        },
    },

    methods:
    {
        handleClick()
        {
            if(!this.to) this.$emit('click')
        }
    },
    
    render(h) {
        const classes = {}
        classes[`${this.outline ? 'btn-outline-' : 'btn-'}${this.variant}`] = true
        return h(
            this.to ? 'router-link' : this.href ? 'a' : 'button',
            {
                class: {
                    'btn': true,
                    'btn-block': this.block,
                    'btn-lg': this.large,
                    'btn-sm': this.small,
                    'btn-xl': this.XLarge,
                    'btn-round': this.round,
                    'btn-center': this.center,
                    'font-weight-bold': this.bold,
                    'font-weight-semibold': this.semibold,
                    ...classes
                },
                props:{
                    to: this.to ? this.to.name : this.to,
                    tag: 'button',
                },
                attrs:{
                    href: this.href ? this.disabled ? null : this.href : null,
                    target: this.href && this.blank ? '_blank': null,
                    disabled: this.disabled
                },
                on: {
                    click: this.handleClick
                }
            },
            [
                this.icon ? h(
                    'justfit-icon',
                    {
                        class: {
                            'mr-1': this.$slots.default
                        },
                        attrs: {
                            icon: this.icon,
                            size: this.size,
                            brand: this.brand,
                            solid: this.solid,
                        }
                    }
                ) : null,
                h(
                    'span',
                    this.$slots.default
                )
            ]
        )
    },
}
</script>
